import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IAssetEditRouteParams {
    assetId: Guid
}

const AssetEditRoute = new AppRoute<IAssetEditRouteParams>({
    route: "/asset/:assetId/edit",
    navbar: true,
    authRequired: true,
})

export default AssetEditRoute
